export default function () {

  const widgetName = 'faircountdownSlideshow';
  const widgetOpts = faircountdownSlideshowOpts;

  // Autoplay and alignment for mobile settings 
  const verticalAlignment = true;
  const autoPlay = true;
  const autoPlaySpeed = 6000;

  // AutoPlay config
  function autoPlaySetting() {
    return autoPlay ? { delay: autoPlaySpeed } : false;
  }

  // Vertical Alignment for mobile config
  function alignmentMobile(data) {
    return verticalAlignment ? {
      direction: 'vertical',
      spaceBetween: 30,
      slidesPerView: data,
      freeMode: true,
      loop: true,
    } : {
      spaceBetween: data > 1 ? 20 : 0,
      slidesPerView: 1,
      slidesPerView: 'auto',
      freeMode: true,
      loop: data > 1,
      centeredSlides: true,
    };
  }

  const swiperContainers = `
    <div class="swiper-container">
      <div class="swiper-wrapper">
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  `;

  // Slide Template
  function buildSlideTemplate(slide) {
    const title = `<h2>${slide.Title.slice(0, 50)}</h2>`;
    const description = slide.Description ? `<p>${slide.Description}</p>` : '';

    const buttons = (btn1, btn1Text, btn2, btn2Text) => {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn2) {
          btnContainer.append(`<a href="${btn2}" class="button btnMore">${btn2Text}</a>`);
        }
        if (btn1) {
          btnContainer.append(`<a href="${btn1}" class="button btnBuy">${btn1Text}</a>`);
        }
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    };

    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
        <div class="swiper-content-container">
          ${title}
          ${description}
        </div>
      </div>
    `;
    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);

    widgetData.forEach((slide, i) => {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      autoplay: autoPlaySetting(),
      loop: widgetData.length > 1,
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 30,
      freeMode: false,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      a11y: true,
      autoHeight: true,

      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        clickable: true
      },
      breakpoints: {
        // 800: alignmentMobile(widgetData.length),
      }
    });
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then((response) => {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
      $('body').addClass('countdownnodata');
    }
  });
}
